
// import { Spin } from 'antd';
const Loader = () => {
    return (  
        <>
      {/* <div className="loader-overlay">
          <div className="loader-container">
              <Spin size="large" />
          </div>
      </div> */}
    <div className="g_loader">
        <div className="loader">
        <div className="loader-inner">
            <div className="loader-line-wrap">
                <div className="loader-line"></div>
            </div>
            <div className="loader-line-wrap">
                <div className="loader-line"></div>
            </div>
            <div className="loader-line-wrap">
                <div className="loader-line"></div>
            </div>
            <div className="loader-line-wrap">
                <div className="loader-line"></div>
            </div>
            <div className="loader-line-wrap">
                <div className="loader-line"></div>
            </div>
        </div>
    </div>
    </div>
    </>
    )
}

export default Loader;
